<template>
  <!-- 機器管理 -->
  <div id="DeviceManagementDetail">
    <div id="container">
      <div class="labelTitle lable">機器詳細</div>
      <div class="button-area"><b-button class="backButton is-primary" v-on:click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>種別</th>
              <td>{{data.inspectionKind}}</td>
            </tr>
            <tr>
              <th>品目コード</th>
              <td>{{data.itemCode}}</td>
            </tr>
            <tr>
              <th>品目名称</th>
              <td>{{data.itemName}}</td>
            </tr>
            <tr>
              <th>シリアル</th>
              <td>{{data.serial}}</td>
            </tr>
            <tr>
              <th>状態</th>
              <td>
                <select v-model="data.statusCode">
                  <option v-for="machineStatus of machineStatusList" :value="machineStatus.value" :key="'s' + machineStatus.value">
                    {{machineStatus.label1}}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th>受付番号</th>
              <td>
                <a v-if="hstDevice != null" @click="showDetailHST()">{{data.receptionNo}} <b-icon icon="vector-arrange-above"/></a>
                <a v-if="kenshinDevice != null" @click="showDetailKenshin()">{{data.receptionNo}} <b-icon icon="vector-arrange-above"/></a>
                <a v-if="holterDevice != null" @click="showDetailHolter()">{{data.receptionNo}} <b-icon icon="vector-arrange-above"/></a>
              </td>
            </tr>
            <tr>
              <th>返却日</th>
              <td v-if="hstDevice != null || kenshinDevice != null || holterDevice != null">{{data.scheduledReturnDate}}</td>
            </tr>
            <tr>
              <th>保管場所</th>
              <td><input type="text" v-model="data.storageLocation" maxlength="100"/></td>
            </tr>
            <tr>
              <th>入庫日</th>
              <td><input type="date" name="入庫日" class="update-validate" validate="date" v-model="data.warehousingDate" /></td>
            </tr>
            <tr>
              <th>リース開始日</th>
              <td><input type="date" name="リース開始日" class="update-validate" validate="date" v-model="data.leaseStartDate" /></td>
            </tr>
            <tr>
              <th>リース終了日</th>
              <td><input type="date" name="リース終了日" class="update-validate" validate="date" v-model="data.leaseEndDate" /></td>
            </tr>
            <tr>
              <th>リースアップ日</th>
              <td><input type="date" name="リースアップ日" class="update-validate" validate="date" v-model="data.leaseUpDate" /></td>
            </tr>
            <tr>
              <th>備考</th>
              <td><textarea v-model="data.note" maxlength="256" style="resize:vertical;max-width:100%;"/></td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="is-primary" @click="update">更新する</b-button>
        </div>
        <div class="button-area"></div>
        <div class="card-content margin-top">
        　<span style="font-size:20px;">機器履歴</span>
          <div>
            <table class="historyTable">
              <tr>
                <th class="date">日付</th>
                <th class="operation">操作</th>
                <th class="detail">内容</th>
                <th class="operator">操作者</th>
              </tr>
            </table>
          </div>
          <div class="historyTable-area">
            <table class="historyTable">
              <template v-for="(history, index) in historyData" >
                <tr :key="index">
                  <td class="date">{{history.date}}</td>
                  <td class="operation">{{history.operation}}</td>
                  <td class="detail" style="word-break: break-all;">{{history.contents}}</td>
                  <td class="operator">{{history.operator}}</td>
                </tr>
              </template>
            </table>
          </div>
        </div>
        <div class="button-area">
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
    <floatingDiv v-if="isShowDetailHST" @close="closeDetailHST" title="" width="640px" height="480px" top="100px" right="100px">
      <hstRequestDetail :data="hstDevice"/>
    </floatingDiv>
    <floatingDiv v-if="isShowDetailKenshin" @close="closeDetailKenshin" title="" width="640px" height="480px" top="100px" right="100px">
      <kenshinRequestDetail :data="kenshinDevice"/>
    </floatingDiv>
    <floatingDiv v-if="isShowDetailHolter" @close="closeDetailHolter" title="" width="640px" height="480px" top="100px" right="100px">
      <holterRequestDetail :data="holterDevice"/>
    </floatingDiv>
  </div>
</template>

<script>
import floatingDiv from "@/components/mock/common/FloatingDiv";
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import KenshinRequestDetail from "@/components/mock/common/KenshinRequestDetail";
import HolterRequestDetail from "@/components/mock/common/HolterRequestDetail";
import {choicesType} from "@/components/mock/base/const.js";
import {machineStatus} from "@/components/mock/base/const.js";

export default {
  name: "DeviceManagementDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "DeviceManagement",
        params: {searchCondition: this.searchCondition}
      });
    },
    update: function() {
      var elements = document.getElementsByClassName("update-validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        if (!this.data.itemName) {
          this.showErrorMessage("正しいの品目コードを指定してください。")
          return
        }

        var obj = JSON.parse(JSON.stringify(this.data));
        obj.warehousingDate = obj.warehousingDate ? obj.warehousingDate.replace(/-/g, "/") : obj.warehousingDate;
        obj.leaseStartDate = obj.leaseStartDate ? obj.leaseStartDate.replace(/-/g, "/") : obj.leaseStartDate;
        obj.leaseEndDate = obj.leaseEndDate ? obj.leaseEndDate.replace(/-/g, "/") : obj.leaseEndDate;
        obj.leaseUpDate = obj.leaseUpDate ? obj.leaseUpDate.replace(/-/g, "/") : obj.leaseUpDate;

        var beforeObj = JSON.parse(JSON.stringify(this.dataOrg));
        beforeObj.warehousingDate = beforeObj.warehousingDate ? beforeObj.warehousingDate.replace(/-/g, "/") : beforeObj.warehousingDate;
        beforeObj.leaseStartDate = beforeObj.leaseStartDate ? beforeObj.leaseStartDate.replace(/-/g, "/") : beforeObj.leaseStartDate;
        beforeObj.leaseEndDate = beforeObj.leaseEndDate ? beforeObj.leaseEndDate.replace(/-/g, "/") : beforeObj.leaseEndDate;
        beforeObj.leaseUpDate = beforeObj.leaseUpDate ? beforeObj.leaseUpDate.replace(/-/g, "/") : beforeObj.leaseUpDate;

        // Web Api Call
        var _this = this;
        this.apiCall(
          function(client){
            return client.apis.internalDeviceManagement.setDeviceUpdatePOST({
              body:{
                before: beforeObj,
                after: obj
              }
            });
          },
          async function(result){
              _this.showSuccess(result, function(){
              //前画面に戻る
              _this.back();
            });
          },
          function(result){
            _this.showErrorMessage(result);
          }
        ); 
      }
    },
    getHistory: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceHistoryPOST({
            body:{id: _this.dataOrg.id}
          });
        },
        function(result){
          _this.historyData = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    // HST 貸出中機器
    getHstReturnDevice: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalHst.getHstReturnDevicePOST({
            body:{
              serial: _this.data.serial,
              status: [machineStatus.deviceReady + "", machineStatus.shipping + "", machineStatus.overdue + ""]
            }
          });
        },
        function(result){
          _this.hstDevice = result.obj.applicationDetails
        },
        function(result){
        }
      ); 
    },
    // 企業検診 
    getKenshinReturnDevice: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalKenshin.getKenshinReturnDevicePOST({
            body:{
              serial: _this.data.serial,
              status: [machineStatus.deviceReady + "", machineStatus.shipping + "", machineStatus.overdue + ""]
            }
          });
        },
        function(result){
          _this.kenshinDevice = result.obj.applicationDetails
        },
        function(result){
        }
      ); 
    },
    getHolterReturnDevice: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalHolter.getHolterReturnDevicePOST({
            body:{
              serial: _this.data.serial,
              status: [machineStatus.deviceReady + "", machineStatus.shipping + "", machineStatus.overdue + "", machineStatus.depositDeviceReady + "", machineStatus.depositShipping + "", machineStatus.depositScheduledReturned + ""]
            }
          });
        },
        function(result){
          _this.holterDevice = result.obj.applicationDetails
        },
        function(result){
        }
      ); 
    },
    getItemName: function(itemCode, itemName){
      var item = this.itemData.find(item => {
        return item.itemCode == itemCode && !item.deleteFlag
      })

      if (item) {
        return item.itemName;
      }
    },
    getDeviceModels: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceModelsPOST({
            body:{}
          });
        },
        function(result){
          _this.itemData = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    showDetailHST: function() {
      this.isShowDetailHST = true;
    },
    closeDetailHST: function(){
      this.isShowDetailHST = false;
    },
    showDetailKenshin: function() {
      this.isShowDetailKenshin = true;
    },
    closeDetailKenshin: function(){
      this.isShowDetailKenshin = false;
    },
    showDetailHolter: function() {
      this.isShowDetailHolter = true;
    },
    closeDetailHolter: function(){
      this.isShowDetailHolter = false;
    }
  },
  data() {
    let data = this.$route.params["data"];
    let searchCondition = this.$route.params["searchCondition"];
    let machineStatusList = this.getChoiceList(choicesType.machineStatus, true)

    let dataOrg = JSON.parse(JSON.stringify(data))
    return {
      data: data,
      dataOrg: dataOrg,
      searchCondition: searchCondition,
      historyData: [],
      isShowDetailHST: false,
      isShowDetailKenshin: false,
      isShowDetailHolter: false,
      machineStatusList: machineStatusList,
      hstDevice: null,
      kenshinDevice: null,
      holterDevice: null,
    };
  },
  filters: {},
  components: {
    floatingDiv: floatingDiv,
    hstRequestDetail:HSTRequestDetail,
    kenshinRequestDetail:KenshinRequestDetail,
    holterRequestDetail:HolterRequestDetail
  },
  mounted: async function() {
    this.getHistory();
    this.getHstReturnDevice();
    this.getKenshinReturnDevice();
    this.getHolterReturnDevice();
    this.getDeviceModels();
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.historyTable-area {
    max-height:500px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.historyTable {
    width: 1150px !important;
}
.historyTable .date {
    width:120px !important;
}
.historyTable .operation {
    width:80px !important;
}
.historyTable .detail {
    width:500px !important;
}
.historyTable .operator{
    width:250px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/device/DeviceManagementDetail.vue